<template>
    <div>
        <section class="p-t-50--xl m-b-50 hero">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="hero__inner hero__inner--float hero__inner--float-small">

                            <div class="row hero__inner-content">
                                <div class="hero__inner-content-column col-12 col-xl-8 offset-xl-2">
                                    <img
                                        v-if="contentLogo"
                                        :src="contentLogo"
                                        :alt="contentTitle"
                                        width="300"
                                    />
                                    <h1 v-if="!contentLogo">{{ $t('search.title') }}<span></span></h1>
                                    <p>{{ $t('search.intro') }}</p>
                                    <div class="hero__inner-content-float hero__inner-content-float--form">
                                        <div class="input-group">
                                            <form v-on:submit.prevent="submit">
                                                <input type="text" v-model="searchField"
                                                       autofocus :placeholder="$t('search.placeholder')" class="m-b-30">
                                                <button type="submit" class="button _resize">{{ $t('search.button') }}</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="results" class="base _off-section _results bg--lightgrey">
            <div class="container p-t-50 p-b-50" v-if="has_searched === true">
                <div class="row">
                    <div class="col-12">
                        <div class="results-top container d-flex align-items-center" v-if="results.length > 0 && is_searching === false">
                            <div class="info m-b-30 m-b-0--md">
                                <h3 class="color--font m-b-0">
                                    {{ pagination.total || 0 }}
                                    {{ pagination.total === 1 ? $t('search.result') : $t('search.results') }} {{ $t('search.found') }}
                                </h3>
                            </div>
                            <div class="actions d-flex align-items-center">
                                <div class="filter d-inline-block">
                                    <CustomSelect
                                        :select-class="'gifty-select'"
                                        :select-id="'filter'"
                                        :options="industries"
                                        :selected="industryField"
                                        @changed="selectUpdated"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div v-if="results.length === 0 && is_searching === false" class="empty-result">
                        <h3>{{ $t('search.noResults') }}</h3>
                        <p>{{ $t('search.noResultsDescription') }}</p>
                    </div>


                    <CompanyCard v-for="(result, index) in results" :key="index" :position="index + 1" :data="result"/>

                    <div class="container" v-if="is_searching">
                        <div class="sk-chase">
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                        </div>
                    </div>
                </div>

                <Observer @intersect="intersected" @options="observerOptions"/>
            </div>
        </section>
    </div>
</template>

<script>
import CustomSelect from './CustomSelect'
import Observer from './Observer'
import CompanyCard from './CompanyCard'

export default {
    name: 'Search',

    components: {
        CustomSelect,
        CompanyCard,
        Observer
    },

    props: {
        contentLogo: {
            type: String,
            default: ''
        },
        search: {
            type: String
        },
        industry: {
            type: String
        },
        filterIndustries: {
            type: Array,
            default: null,
        },
        filterPostalCodes: {
            type: Array,
            default: null,
        },
        filterCountries: {
            type: Array,
            default: null,
        },
        campaign: {
            type: String,
            default: null
        },
        widget_key: {
            type: String
        },
        searchOnMount: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            searchField: '',
            industryField: 'all',

            has_searched: false,
            is_searching: false,
            end_of_results: false,

            observerOptions: {
                root: document.querySelector('#results'),
                rootMargin: '500px'
            },

            pagination: {},

            results: [],
            filters: {
                industries: {}
            },
        }
    },

    watch: {
        results: function (value) {

            if (value.length === 0) {
                return;
            }

            // GA
            let gaOptions = {
                currency: 'EUR',
                items: []
            }

            value.forEach(function (item, index) {
                const position = index + 1

                gaOptions.items.push({
                    item_id: item.id,
                    item_name: 'Gift Card',
                    item_brand: item.name,
                    item_category: item.industry,
                    item_list_name: 'Search Results',
                    index: position,
                })
            })
        }
    },

    computed: {
        industries: function () {
            return {
                all: 'Alle branches',
                ...this.filters.industries
            }
        }
    },

    mounted() {
        const queryString = window.location.search
        const queryParams = new URLSearchParams(queryString)

        if (queryParams.get('search') || queryParams.get('branche')) {
            this.searchField = queryParams.get('search') ?? ''
            this.industryField = queryParams.get('industry') ?? 'all'
            this.submit()
        } else if (this.searchOnMount === true) {
            this.submit()
        }
    },

    methods: {
        intersected() {
            this.getSearchResults(this.pagination.to)
        },

        selectUpdated(industry) {
            this.industryField = industry
            this.submit()
        },

        getSearchResults(from = 0) {
            if (
                this.end_of_results === true ||
                this.is_searching
            ) {
                return
            }

            this.is_searching = true

            let query = {
                from: from,
            }

            if (this.searchField.length >= 3) {
                query.query = this.searchField
            }

            if (this.campaign !== null) {
                query.filter_campaign = this.campaign
            }

            if(this.industryField !== 'all' || this.filterIndustries !== null) {
                query.filter_industries = []

                if (this.industryField !== 'all') {
                    query.filter_industries.push(this.industryField)
                }

                if (this.filterIndustries !== null) {
                    query.filter_industries.push(...this.filterIndustries)
                }
            }

            if (this.filterPostalCodes !== null) {
                query.filter_postal_codes = this.filterPostalCodes
            }

            if (this.filterCountries !== null) {
                query.filter_countries = this.filterCountries
            }

            axios.post(`/api/search`, query)
                .then((response) => {
                    this.results.push(...response.data.data)
                    this.pagination = response.data.meta

                    if (
                        Object.keys(response.data.filter.industries).length >=
                        Object.keys(this.filters.industries).length
                    ) {
                        this.filters.industries = response.data.filter.industries
                    }
                })
                .finally(() => {
                    this.is_searching = false

                    if (this.pagination.total === this.results.length) {
                        this.end_of_results = true
                    }
                })
        },

        submit() {
            if (this.searchField.length < 3 && this.searchOnMount === false) {
                return
            }

            this.end_of_results = false
            this.results = []
            this.has_searched = true

            this.getSearchResults()

            // Update URL param
            let queryParameters = new URLSearchParams(window.location.search)
            queryParameters.set('search', this.searchField)
            queryParameters.set('industry', this.industryField)
            history.replaceState(null, null, '?' + queryParameters.toString())

            $([document.documentElement, document.body]).animate({
                scrollTop: $('#results').offset().top - 100
            }, 500)
        }
    }
}
</script>
